import React, { useEffect, useRef, useState } from 'react'
import { ACCEPTABLE_FILE_TYPES, MAX_NUM_FILES } from '../../Configuration'
import './upload-file.css'
import InputLabel from '../../utils/input-label'
import Alert from '../../components/alert/alert'


interface Props {
  onFileChange?: any,
  label?: any,
  hint?: any,
  inputProps?: any,
  infoClassName?: any,
  info?: any,
  infoIcon?: any,
  isInfo?: any,
  formClassName?: any,
  files?: any,
  setFiles?: any,
  disabled?: any,
  hintClassName?: any,
  note?: any,
  noteClassName?: any,
  error?: any,
  mandatory?: any,
  setFileError?: any
  fileError?: boolean
  isPMGFile?: boolean
  position?: string
  labelclassName?: any
  fileLength?: number
  fileFormat?: string
  fileFormatArr?: string[]

}
export const FileUpload = (props: Props) => {
  const wrapperRef = useRef<any>(null)
  const [fileList, setFileList] = useState<any>(props?.files ? props?.files : [])
  const onDragEnter = () => wrapperRef.current.classList.add('dragover')
  const onDragLeave = () => wrapperRef.current.classList.remove('dragover')
  const { setFiles, label, info, isInfo, hint, files } =
    props
  const [dragActive, setDragActive] = useState<boolean>(false)
  const [fileErrors, setFileErrors] = useState<Array<FileError>>([])
  const [showAlert, setShowAlert] = useState(false)
  const [removeAlert, setRemoveAlert] = useState(false)
  const [existingFiles, setExistingFiles] = useState<string[]>()
  const [deleteFile, setDeleteFile] = useState<any>(null)
  const [newFiles, setNewFiles] = useState<Array<File>>([])
  const [validatedFiles, setValidatedFiles] = useState<Array<File>>([])
  const [detailviewexistingFiles, setDetailviewExistingFiles] = useState<string[]>([])
  const [detailviewShowAlert, setDetailviewShowAlert] = useState(false)
  useEffect(() => {
    setFileList(props?.files)
    if (props?.files?.length === 0) {
      setFileErrors([])
    }
  }, [props?.files])
  const addFileHandler = () => {
    document.getElementById('attachFile')!
  }
  const checkFilesAlreadyExist = (newFiles: Array<File>): Array<string> => {
    const existingFiles: Array<string> = []
    newFiles.forEach((file: File) => {
      if (files?.filter((f: any) => (f?.name ? f?.name : f?.FileName) === file.name).length > 0) {
        existingFiles.push(file.name)
      }
    })
    return existingFiles
  }
  function DocumentIconNames(file: string): string {
    const fileExtension = file?.split('.').pop() ? file?.split('.')?.pop()?.toLowerCase() : ''

    const iconName = (
      fileExtension === 'ppt' || fileExtension === 'pptx'
        ? 'icon-rb-ms-ppt-pages icon-pptcolor'
        : fileExtension === 'pdf'
          ? 'icon-file-pdf-fill icon-pdfcolor icon-rb-file-pdf-earmark'
          : fileExtension === 'doc' || fileExtension === 'docx'
            ? 'icon-rb-ms-word-file color-primary'
            : fileExtension === 'xlsx' || fileExtension === 'xls'
              ? 'icon-excel icon-excelcolor icon-rb-ms-excel-report'
              : fileExtension === 'txt'
                ? 'icon-file-doc color-primary mb-1'
                : fileExtension === 'png'
                  ? 'icon-image icon-png-jpgcolor icon-rb-file-png '
                  : fileExtension === 'jpg' || fileExtension === 'jpeg'
                    ? 'icon-rb-file-jpg'
                    : fileExtension === 'msg'
                      ? 'icon-rb-email'
                      : 'icon-emptyfile'
    )
    return iconName
  }

  const getFileExtensionByFileName = (fileName: string): string => {
    if (!fileName) return '';
    const ext = fileName.split('.').pop();
    return ext?.toLowerCase() || '';
  }
  const FILE_CHARACTERS_UNALLOWED = [',', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '[', ']', '{', '}', 'ʻ', ':', '“', '|', '<', '>', '/', '?', '~']
  const MAX_FILE_SIZE = 25000000
  const validateFile = (file: File, supportedFiles: string[]): [boolean, Array<any>] => {
    let valid = true
    const errors: Array<any> = []
    const FileTypes = supportedFiles
    const ext = getFileExtensionByFileName(file.name)
    if (file.size > MAX_FILE_SIZE) {
      errors.push({ fileName: `${file.name}`, message: 'File cannot exceed 25MB.' })
      valid = false
    }
    if (FileTypes.indexOf(ext) === -1) {
      errors.push({ fileName: `${file.name}`, message: `File type is not allowed. Acceptable file types are ${FileTypes.join(', ')}.` })
      valid = false
    }
    if (FILE_CHARACTERS_UNALLOWED.some(char => file.name.includes(char))) {
      errors.push({ fileName: `${file.name}`, message: `The file(s) were not uploaded because the file name(s) contain unallowed characters are ${FILE_CHARACTERS_UNALLOWED.join(' ')}.` })
      valid = false
    }
    return [valid, errors]
  }
  type FileError = {
    fileName: string
    message: string
  }
  const validateFiles = (files: Array<File>): [boolean, Array<FileError>] => {
    let valid = true
    const errors: Array<FileError> = []
    const acceptedFileTypes = props?.fileFormatArr && props?.fileFormatArr.length > 0 ? props?.fileFormatArr : ACCEPTABLE_FILE_TYPES
    files.forEach((file: File) => {
      const [fileValid, error] = validateFile(file, acceptedFileTypes)
      if (!fileValid) {
        valid = false
        errors.push(...error)
      }
    })
    return [valid, errors]
  }

  const onRespondClick = (userDecision: string) => {
    let newFileItem: Array<File> = []
    if (userDecision === 'Replace') {
      setFiles((prevFiles: any[]) => prevFiles.filter((file: any) => !(existingFiles ? existingFiles : detailviewexistingFiles)?.includes(file?.name ? file?.name : file?.FileName))?.concat(validatedFiles))
      setFileList((prevFiles: any[]) => prevFiles.filter((file: any) => !(existingFiles ? existingFiles : detailviewexistingFiles)?.includes(file?.name ? file?.name : file?.FileName))?.concat(validatedFiles))
      setShowAlert(false)
      setDetailviewShowAlert(false)
    } else {
      newFileItem = validatedFiles?.filter((file: any) => !(existingFiles ? existingFiles : detailviewexistingFiles)?.includes(file?.name ? file?.name : file?.FileName))
      setFiles(files.concat(newFileItem))
      setFileList(files.concat(newFileItem))
      setShowAlert(false)
      setDetailviewShowAlert(false)
    }
  }
  const handleFileUploadChange = (e: any, type: 'Click' | 'Drag') => {
    const fileLength = props?.fileLength !== undefined && props?.fileLength > 0 ? props.fileLength : MAX_NUM_FILES
    e.preventDefault()
    setFileErrors([])
    let newFiles: Array<File> = Array.from(type === 'Click' ? e.target.files : e.dataTransfer.files)
    setNewFiles(newFiles)
    const [valid, errors] = validateFiles(newFiles)
    const validatedFiles = newFiles?.filter((newFile: any) => {
      return !errors.some(invalidFile => invalidFile.fileName === newFile.name)
    })
    setValidatedFiles(validatedFiles)
    const existingFiles: string[] = checkFilesAlreadyExist(validatedFiles)
    const hasDetailViewDuplicate = fileList.some((file: any) => existingFiles.includes(file?.name ?? file?.FileName) && file?.isUploded)
    if (hasDetailViewDuplicate) {
      setDetailviewExistingFiles(existingFiles)
    } else {
      setExistingFiles(existingFiles)
    }


    if (files.length > fileLength || newFiles.length > fileLength || newFiles.length + files.length > fileLength) {
      setFileErrors(prevErrors => [...prevErrors, { fileName: 'Max file upload limit exceeded', message: `Maximum of ${fileLength} files can be uploaded.` }])
      return
    }
    if (!valid) {
      errors.map((error: FileError) => setFileErrors(prevErrors => [...prevErrors, { fileName: error.fileName, message: error.message }]))
      newFiles = newFiles.filter((file: File) => !errors.map((error: FileError) => error.fileName).includes(file.name))
    }
    if (hasDetailViewDuplicate) {
      setDetailviewShowAlert(true)
      return
    }
    if (existingFiles.length > 0) {
      setShowAlert(true)
      return
    }
    if (newFiles.length > 0) {
      setFiles(files.concat(newFiles))
      setFileList(files.concat(newFiles))
    }
    if (props?.onFileChange) { props?.onFileChange(files.concat(newFiles)) }
    e.target.value = null
  }

  // triggers when file is selected with click
  const onFileDrop = (e: any) => {
    e.preventDefault()
    if (e.target.files && e.target.files[0]) {
      handleFileUploadChange(e, 'Click')
    }
    e.target.value = null
  }

  // triggers when file is dropped
  const handleDrop = (e: any) => {
    e.preventDefault()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUploadChange(e, 'Drag')
    }
  }
  const handleDrag = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true)
    } else if (e.type === 'dragleave') {
      setDragActive(false)
    }
  }

  const onClickAlert = (file: any) => {
    setDeleteFile(file)
    setRemoveAlert(true)
  }

  const fileRemove = async (button: string) => {
    if (button === 'Yes' && deleteFile) {
      setRemoveAlert(false)
      if (!props?.disabled) {
        const updatedList = [...fileList]
        updatedList.splice(fileList.indexOf(deleteFile), 1)
        setFileList(updatedList)
        setFiles(updatedList)
        if (updatedList?.length === 0 && props?.setFileError) {
          props?.setFileError(false)
        }
        if (props?.onFileChange) {
          props?.onFileChange(updatedList)
        }
        setDeleteFile(null)
      }
    } else {
      setRemoveAlert(false)
      setDeleteFile(null)
    }
  }

  return (
    <>
      <div className="attachments">
        <div className="formgroup mb-1 d-flex flex-column gap-1">
          {props?.label && <InputLabel labelProps={{ htmlFor: props?.inputProps?.id }} label={props?.label} className={props?.labelclassName} infoLabel={props?.info} isinfoLabel={props?.isInfo} isinfoIcon={props?.infoIcon} isinfoClassName={props?.infoClassName} mandatory={props?.mandatory} position={props?.position} />}
          <div id="form-file-upload" className="attachfile dropzonecontrol py-4" >
            <div ref={wrapperRef}
              className="drop-file-input w-100"
              onDragEnter={onDragEnter}
              onDragLeave={onDragLeave}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => handleDrop(e)}
            >
              <label htmlFor="attachFile" className="choosebtn sora-semibold p-relative" title="Drag & drop or choose file to upload">
                Drag & drop or choose file to upload
                <input className='rb-file-input' type="file" name="attachFile" id="attachFile"
                  accept={props.fileFormat ? props.fileFormat : ".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf,.png, .jpg, .jpeg,.gif, .msg"}
                  aria-label="Attach File" multiple onInput={onFileDrop} disabled={!!props?.disabled} aria-labelledby='Drag & drop or choose file to upload' />
              </label>

              {
                fileList?.length > 0
                  ? (
                    <div className="attachmentsdisplay">
                      <ul id="attachments" className="formattach">
                        {
                          fileList.map((item: any, index: number) => (
                            !item?.isUploded &&
                            <li key={item.name}>
                              <div className='file-item d-flex flex-wrap'>
                                <div className='file-icon pe-2'><span className={`${DocumentIconNames(item?.name || item?.FileName)}`}></span></div>
                                <div className="attachedfiles text-break col" title={item.name ? item.name : item.FileName} tabIndex={0} aria-label={item.name ? item.name : item.FileName}>{item.name || item.FileName}
                                  <span className="icon-rb-close" onClick={() => onClickAlert(item)} onKeyDown={(event) => { event.key === 'Enter' && onClickAlert(item) }} title='Close' tabIndex={0} aria-label="Close"></span>
                                </div>
                              </div>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  )
                  : null
              }

              {dragActive && <div id='drag-file-element' onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
              <span id="docerrormsg" className='Spanerrormsgs'>
                {fileErrors && fileErrors?.length > 0 &&
                  <div className="error-list">
                    <span className="error-list-header">Errors:</span>
                    <div>
                      {fileErrors?.map((error: FileError, index: number) => (
                        <div key={index} className="error-item">
                          <div className="error-filename">{error.fileName}</div>
                          <div>{error.message}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </span>
              {props?.error && props?.fileError && fileList?.length == 0 &&
                <div className="drop-file-input"><span id="docerrormsg" className="Spanerrormsgs" style={{ textAlign: 'left', verticalAlign: 'bottom' }}><p className="errormsg">Please Choose/Drag file(s) to upload.</p></span></div>}
            </div>

          </div>
        </div>
        {props?.hint &&
          <span className="hintmsg font-13" tabIndex={0} aria-live='polite'>
            <span className={props?.hintClassName}>Hint:</span> {props?.hint}</span>
        }
        {props?.note &&
          <span className="hintmsg d-block font-13" tabIndex={0} aria-live='polite'>
            <span className={props?.noteClassName}>Note:</span> {props?.note}</span>
        }
      </div>
      {showAlert ?
        <Alert message={`File(s) with the name(s) ${existingFiles?.join(', ')} already exist. Do you want to replace them?`} yes='Replace' cancel='Cancel' className="alert-info"
          alerttextclass='text-break'
          btn1iconclassName='icon-rb-checked  font-12 pe-1'
          btn2iconclassName='icon-rb-close  font-12 pe-1'
          btn1className="btn-border-radius-3 px-2 btn-primary whitetext font-12 text-uppercase btn-xs"
          btn2className="btn-border-1 btn-border-radius-3 px-2  text-color-5 font-12 text-uppercase btn-xs" onClick={onRespondClick} />
        : ''
      }
      {detailviewShowAlert ?
        <Alert message={`File(s) with the name(s) ${detailviewexistingFiles?.join(', ')} already exist in the detail view. Do you want to replace them?`} yes='Replace' cancel='Cancel' className="alert-info"
          alerttextclass='text-break'
          btn1iconclassName='icon-rb-checked  font-12 pe-1'
          btn2iconclassName='icon-rb-close  font-12 pe-1'
          btn1className="btn-border-radius-3 px-2 btn-primary whitetext font-12 text-uppercase btn-xs"
          btn2className="btn-border-1 btn-border-radius-3 px-2  text-color-5 font-12 text-uppercase btn-xs" onClick={onRespondClick} />
        : ''
      }
      {removeAlert && (
        <Alert message={`Are you sure you want to remove ${deleteFile?.name ? deleteFile?.name : deleteFile?.FileName}?`} yes='Yes' cancel='No' className="alert-info"
          alerttextclass='text-break'
          onClick={fileRemove}
          btn1iconclassName='icon-rb-checked  font-11 pe-1'
          btn2iconclassName='icon-rb-close  font-11 pe-1'
          btn1className="btn-border-radius-3 px-2 btn-primary whitetext font-12 text-uppercase btn-xs"
          btn2className="btn-border-1 btn-border-radius-3 px-2  text-color-5 font-12 text-uppercase btn-xs"

        />
      )}
    </>
  )
}
export default FileUpload
